import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
    name: "flightStatus",
    standalone: false,
})
export class FlightStatusPipe implements PipeTransform {
    constructor(private _translate: TranslateService) {}

    transform(statusId: number): string {
        switch (statusId) {
            case 3:
                return this._translate.instant("FLIGHTS.UPDATE.cancelled");
            case 2:
                return this._translate.instant("FLIGHTS.UPDATE.pending");
            default:
                return this._translate.instant("FLIGHTS.UPDATE.ok");
        }
    }
}
